<template>
    <div>
    
      <section  class="navbarsection" style="margin-top: -50px;">
            <div class="txtdata">
              <h1  style="padding-top: 200px;"></h1>
            </div>
              <div class="videosection" >
                <div  v-show="pvisvideo === true && pvpictureimage === false ">
                  <Transition class="transition thing">
                    <video-background 
                      playbackRate=0.98
                      :src="src"
                      :poster="poster"
                      :class="`thing playercss`"
                      :style="`height: 600px;`">
                    </video-background>
                  </Transition>
                </div>
              
                  <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                  </div>
        
                  <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                  v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
         
            </div>
            <div class="overlay"></div>
            <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
              <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
            </div>
          </section>
      
    
    
     <div class="seven3css">
      <SeventyThirtysection :LeftsideText="jotlefttext" :RightsideText="transhighlight" leftsectheme="leftseccss" />
    </div>
   
   
  
<section class="goalsperfsec">
  <div>
    <div class="jouteamcss"> {{ joteampositiontext }}</div>
  </div>
    <div class="tablediv">
    <DynamicTable :getTableCaptions="tabledata" :getjobs="careerpagejobs" :getregions="careerregions" @click="getLinkedID($event)"/>
    </div>
</section>   

  
      <section class="bottomsec">
        <div>
          <hr class="hrclass"/>
          <span v-html="joteambottomtext" class="hrspantext">
  
          </span>
        </div>
         
  
      </section>
      <section style="height: 40px;">
      </section>
     
    </div>
  </template>
  
  <script>

  import DynamicTable from '@/components/DynamicTable.vue';

  import SeventyThirtysection from '@/components/SeventyThirtysection.vue';

  require('@/assets/css/pannellium-2.5.css');
  require('@/assets/css/video-js.css');
  import axios from 'axios';
  import { useRoute, useRouter } from 'vue-router'
  require('@/globalDeclare');
  
  const router = useRouter()
  const route = useRoute()
  
  
  export default {
    name: 'AboutView',
    components: {
   DynamicTable, SeventyThirtysection,
  },
  data() {
    return {
    videoimage: [],
    imagetext: '',
    src: '',
    playrate: '',
    poster: '',
    // pvwebm: '',
    // pvmp4: '',
    pvstyle: '',
    pvsrc: '',
    pvisvideo: false,
    pvpanorama1: '',
    pvpanorama2: '',
    pvpanorama3: '',
    pvhotspot1: '',
    pvhotspot2: '',
    pvhotspot3: '',
    showVideo: false,
    showPanorama: false,
    picurl: myUrlPath,

  
    breadcrumbsinfo: [],
    alljoinourteamdata: [],
    aboutgeneral: [],
  
    jotlefttext: '',
    joteampositiontext:  '',
    joteambottomtext:  '',
  
    //pagination props
    ophotos: [],
    page: 1,
    perPage: 1,
    pages: [],
    totalPages: 0,
    displayedPhotos: [],
  
    tabledata: [],
    careerpagejobs: [],
    careerregions: [],
    getjobposting: [],
    
    histsearchid: 0,
    publicPath: window.location.origin
    }
  },
  methods: {
  getPhotos() {
      axios.get('homepageotheruploadlisting/joinourteam').then(
            response => {
            this.ophotos = response.data;
            this.totalPages = response.data.length;
          })
          .catch(response => {
              console.log(response);
          });
      },
  getLinkedID($event) {
    let lkId = $event.target.value
    let locallang = localStorage.getItem('lang')
    let vm = this
    if(locallang === 'en'){
      vm.$router.push({name: 'jobposting', params: {jobid: lkId}})
    }
    if(locallang === 'fr'){
      vm.$router.push({name: 'offredeemploi', params: {jobid: lkId}})
    }
    
    //-----------All career page jobs-------------
    axios.get(`getuniquejob/${lkId}`).then(
          response => {
              this.getjobposting = response.data
              console.log(this.getjobposting)
        })
        .catch((error) => {
            console.log(error)
          }) 
  
        
  }
  },
  created() {
          this.getPhotos();
  },
  
mounted() {
    let showImage = Boolean
    showImage = false
  axios.get('allpagespv/joinourteam').then(
      response => {
      this.videoimage = response.data
        
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage
  
        // let pvisvideo1 = this.videoimage.pvisvideo
        // this.pvisvideo = pvisvideo1
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -237.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.6,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                    hotSpots: [
                        {
                            pitch: 4,
                            yaw: 21.8,
                            type: "scene",
                            sceneId: "anotherhotspot",
                            text: this.pvhotspot1,
                        }
                    ]
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "lasthotspot",
                              text: this.pvhotspot2,
                          }
                      ]
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "hotspotoffice",
                              text: this.pvhotspot3,
                          }
                      ]
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
    })
    .catch((error) => {
          console.log(error)
        })
    
  //------------breadcrumbs mappings info---------------
  axios.get('getbreadcrumbsinfo/joinourteam').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })  
  
      //-----------All invest page report data--------------
      axios.get('getjoinourteaminfo/').then(
      response => {
          this.alljoinourteamdata = response.data
          this.jotlefttext = response.data[0].jotlefttext
          this.joteampositiontext = response.data[0].joteampositiontext
          this.joteambottomtext = response.data[0].joteambottomtext

      })
    .catch((error) => {
        console.log(error)
      }) 
    
    //------------all highlights---------------
  axios.get('getallhiglights/joinourteam').then(
      response => {
          this.transhighlight = response.data[0].highlightdesc
    })
    .catch((error) => {
        console.log(error)
      })

  
  //-----------Homepage NewsPhoto section-------------
  axios.get('newsphotos/').then(
        response => {
            this.newsphotos = response.data
            this.newsphoto = response.data[0]['newsphoto']
      })
      .catch((error) => {
          console.log(error)
        })  
  
  //-----------All career table captions-------------
  axios.get('getallcareertablecaption/').then(
        response => {
            this.tabledata = response.data
      })
      .catch((error) => {
          console.log(error)
        })  
    
  //-----------All regions-------------
  axios.get('getallcareerallregions/').then(
        response => {
            this.careerregions = response.data
      })
      .catch((error) => {
          console.log(error)
        }) 
    
  //-----------All career page jobs-------------
  axios.get('getallcareerspagejobs/').then(
        response => {
            this.careerpagejobs = response.data
      })
      .catch((error) => {
          console.log(error)
        }) 
  
  
  }
  }
  </script>
  
  <style scoped>
  .stockcards {
    padding-top: 200px;
  }
  
  .container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: .2fr 1.2fr .2fr;
    grid-template-areas: 
    "nav nav nav" 
    "main main main" 
    "footer footer footer";
    grid-gap: 0.2rem;
    font-family: "Inter", sans-serif;
    font-size: 800;
    font-size: 12px;
    color: #234234;
    text-align: center;
  }
  
  html { 
    height: 100%;
    margin:0px;
    background: url('../assets/slide-5.jpg') no-repeat center center;
    background-size: cover;
    background-attachment: fixed;
  }
  
  main {
    background: white;
    grid-area: main;
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-radius: 0px;
    margin-top:-5px;
  }
  
  .yearscontainer {
    background-color: grey;
    margin-top: -200px;
   }
  .yearscontainergifbtm {
    margin-bottom: 20px;
  }
  .bottomsec{
    font-size: 18px;
    text-align: justify;
    border-top: solid thin grey;
    padding: 100px;
  }
  .hrspantext {
    padding-top: 10px;
  }
  .stockcss {
    margin-top: 100px;
    width: 70%;
  }
  .stockcss1 {
    margin-top: -190px;
    width: 70%;
  }

   .tablediv {
    padding-left: 100px;
    padding-right: 100px;
}
 .jouteamcss {
  font-size: 36px;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-weight: bold;
  color: rgb(148, 82, 58);
  padding-left: 100px;
  padding-bottom: 20px;
 } 
 .seven3css {
  margin-top: 250px;
 }
 .videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
  /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .bottompagemsg{
      margin-bottom: -350px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
      
    }
  
    .stockcss {
      width: 98%;
      margin-top: 100px;
      margin: 0 auto;
      padding: 20px;   
      }
    .pantopsection {
      margin-top: 100px;
     }
    
     .txtdata {
      margin-bottom: 100px;
      width: 400px;
      padding-right: 10px;
    }
    .tablediv {
      overflow-y: scroll;
      padding-left: 10px;
    }
    .seven3css {
      margin-top: 200px;
    }
    .bottomsec, .interestcss {
      padding-left: 30px;
      padding-right: 30px;
    }
    .jouteamcss {
      font-size: 20px;
    }
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
    .bottompagemsg{
      margin-bottom: -200px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
    .stockcss {
      width: 98%;
      margin-top: 100px;
      margin: 0 auto;
      padding: 20px;   
      }
    .pantopsection {
      margin-top: 100px;
     }
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
    .bottompagemsg{
      margin-bottom: -200px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
    .pantopsection {
      margin-top: 250px;
     }
   }
  
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
    .bottomsec{
      text-align: justify;
      padding-left: 100px;
      padding-right: 100px;
    }
    .panimagesize {
      margin-top: 130px;
    }
    .interestcss {
      padding: 100px;
    }
   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
    .bottompagemsg{
      margin-bottom: -100px;
      text-align: justify;
      padding-left: 30px;
      padding-right: 30px;
    }
    .pantopsection {
      margin-top: 100px;
    }
    .goalsperfsec {
      padding-right: 50px;
      padding-left: 50px;
    }
   } 
  
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1400px) {
  
    .stockcss {
      width: 68%;
      margin-top: 100px;
      margin: 0 auto;
      padding: 20px;   
      }
    .pantopsection {
      margin-top: 100px;
     }
    } 
  
  </style>
  